import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useValues} from './';

const defaultValues = {
    destination: null,
    destinationUuid: undef,
    subDestination: null,
    listingProps: null
};

function useDestinationValues(props, cookies) {
    const {
        destinationValues: propsValues
    } = props;

    const {
        destinationValues: cookiesValues
    } = cookies;

    const {
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    } = useValues(defaultValues, cookiesValues, propsValues);

    const result = {
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    };

    useDebugValue(result);

    return result;
}

export {useDestinationValues};
